<template>
  <BreadCrumb :PageTitle="pageTitle" />
    <div class="card mb-25 border-0 rounded-0 bg-white create-role-box">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <form @submit.prevent="createTaskCustomField">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Task Type
                </label>
                <select v-model="selectedTaskType" class="form-select shadow-none fw-semibold rounded-0" disabled>
                  <option v-for="item in taskTypes" :key="item.id" :value="item" >
                     {{ item.taskName }}
                  </option>
              </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Custom Field Name
                </label>
                <input
                  v-model="customFieldName"
                  type="text"
                  class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Administrator"
                  required
                />
              </div>
            </div>
            <div class="col-md-12">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Create Task Custom Field
              </button>

              <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
                pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
                fs-md-15 fs-lg-16 m-5 bg-danger" type="button"> Cancel </button>
                </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, onMounted } from "vue";
  import { AddTaskCustomField, GetAllTaskTypes, FindTaskTypeByID } from '@/core/services/entities/task.service'
  import { useRouter, useRoute } from "vue-router";
  import { useToast } from 'vue-toastification'
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  
  export default defineComponent({
    name: "CreateTaskCustomField",
    components: {
      BreadCrumb
    },
    setup() {
      const customFieldName = ref("");
      const selectedTaskType=ref({ });
      const taskTypes=ref([]);
      const pageTitle = ref("Add Task Custom Field");
      const taskTypeId = ref(0);
      const router = useRouter();
      const route = useRoute();

      onMounted(async () => {
        await getTaskTypeById();
        
      });

      const goToMainMenu = async () => {
        router.push({ name: "TaskCustomFieldListPage", params: {taskTypeId: selectedTaskType.value.id} });
      };

      const getTaskTypeById = async () => {
        taskTypeId.value = route.params.taskTypeId;
        let response = await FindTaskTypeByID(taskTypeId.value);
        taskTypes.value = [ response.taskType ];
        selectedTaskType.value = response.taskType;
        pageTitle.value = "Add Task Custom Field - " + selectedTaskType.value.taskName
      };
  
      const createTaskCustomField = async () => {
        const toast = useToast();
        const payload = { taskTypeId:selectedTaskType.value.id, customFieldName: customFieldName.value };
        
        try {
                let response = await AddTaskCustomField(payload);  
                if (response.status === 200) {
                  toast.success('Task Custom Field added successfully!', {
                    timeout: 2000,
                  });
                  goToMainMenu();
                }
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to added task custom field: ${errorMessage}`, {
                  timeout: 2000,
                });
              }

      };
  
      return {
        customFieldName,
        createTaskCustomField,
        goToMainMenu,
        selectedTaskType,
        taskTypes,
        pageTitle
      };
    },
  });
  </script>
  